import { Heading } from '@findy-code/yuffie/ui/heading';
import { Image } from '@findy-code/yuffie/ui/image';
import { Stack } from '@findy-code/yuffie/ui/stack';
import { Text } from '@findy-code/yuffie/ui/text';
import { gaSendEvent } from '@findy-code/yuffie/utils/events/event/ga-send-event';
import Link from 'next/link';
import { FaLink, FaUserFriends } from 'react-icons/fa';

import styles from './detail-company-title.component.module.scss';
type Props = {
  companyImageAlt?: string;
  companyImageUrl?: string;
  companyUrl: string;
  title: string;
  companyDescription?: string;
  employeeCount?: number | null;
};

export const DetailCompanyTitle = ({
  companyImageAlt,
  companyImageUrl,
  companyUrl,
  companyDescription,
  employeeCount,
  title,
}: Props) => {
  if (!title) {
    return null;
  }

  const roundedEmployeeCount = employeeCount
    ? Math.ceil(employeeCount / 10) * 10
    : null;

  return (
    <Stack spacing={{ base: 12, md: 8 }}>
      <Stack
        align={{ base: 'start', md: 'center' }}
        direction={{ base: 'column', md: 'row' }}
        spacing="xxs"
      >
        <div className={styles.companyImage}>
          {!!companyImageUrl && (
            <Image
              isImgElement
              alt={companyImageAlt ?? ''}
              className={styles.companyTitleLogo}
              data-is-intrinsic-aspect-ratio="true"
              src={companyImageUrl}
            />
          )}
        </div>
        <div>
          <Heading
            className={styles.jobCompanyName}
            font={{ base: 'heading-l', lg: 'heading-xxl' }}
          >
            {title}
          </Heading>
        </div>
      </Stack>
      {!!companyDescription && (
        <Text
          className={styles.companyDescription}
          font={{ base: 'heading-xs', md: 'heading-m' }}
        >
          {companyDescription}
        </Text>
      )}
      <Stack
        align={{ base: 'start', md: 'center' }}
        direction={{ base: 'column', md: 'row' }}
        spacing={{ base: 's', md: 'xxl' }}
      >
        {!!companyUrl && (
          <Link
            className={styles.jobCompanyLinkWrap}
            href={companyUrl}
            onClick={() =>
              gaSendEvent({
                category: 'link',
                action: 'click',
                label: '企業URLクリック',
                nonInteraction: true,
              })
            }
          >
            <span aria-label="企業名" className={styles.jobCompanyLinkIcon}>
              <FaLink aria-hidden color="#8B9195" height={20} width={20} />
            </span>
            {companyUrl}
          </Link>
        )}
        {!!roundedEmployeeCount && (
          <div className={styles.employeeCountWrap}>
            <span aria-label="従業員数" className={styles.employeeCountIcon}>
              <FaUserFriends
                aria-hidden
                color="#8B9195"
                height={20}
                width={20}
              />
            </span>
            {roundedEmployeeCount}人程度
          </div>
        )}
      </Stack>
    </Stack>
  );
};
